module.exports = __webpack_public_path__ + "home-block-3-overlay@2x-39Ph6NJ.png";